import { Api } from 'utils';

class ReportService {

	static getVerifications = async (params?: any) => Api.createResponse('client/reports/verifications',params);
	static getCases = async (params?: any) => Api.createResponse('client/reports/verifications/cases',params);
	static getBlackList = async (params?: any) => Api.createResponse('client/reports/black-list',params);
	static getConsultations = async (params?: any) => Api.createResponse('client/reports/consultations',params);
	
	static admin = {
		getVerifications: async (params?: any) => Api.createResponse('admin/reports/verifications',params),
		viewVerification: async (params?: any) => Api.createResponse('admin/reports/verifications/view',params),
		saveStatus: async (params?: any) => Api.createResponse('admin/reports/verifications/save-status',params),
		addBlackList: async (params?: any) => Api.createResponse('admin/reports/verifications/add-black-list',params),
		getBlackList: async (params?: any) => Api.createResponse('admin/reports/black-list',params),
		getClients: async (params?: any) => Api.createResponse('admin/reports/verifications/clients',params),
		getConsultations: async (params?: any) => Api.createResponse('admin/reports/consultations',params),
		viewConsultation: async (params?: any) => Api.createResponse('admin/reports/consultations/view',params),
		saveDocument: async (params?: any) => Api.createResponse('admin/reports/save-document',params),
		loadChats: async (params?: any) => Api.createResponse('admin/reports/load-chats',params),
		sales: {
			get: async (params?: any) => Api.createResponse('admin/reports/sales',params),
			view: async (params?: any) => Api.createResponse('admin/reports/sales/view',params),
			delete: async (params?: any) => Api.createResponse('admin/reports/sales/delete',params),
		},
		documents: {
			getVerifications: async (params?: any) => Api.createResponse('admin/reports/documents',params),
			view: async (params?: any) => Api.createResponse('admin/reports/documents/view',params),
			saveStatus: async (params?: any) => Api.createResponse('admin/reports/documents/save-status',params),
		},
		bills: {
			getVerifications: async (params?: any) => Api.createResponse('admin/reports/bills',params),
			view: async (params?: any) => Api.createResponse('admin/reports/bills/view',params),
			save: async (params?: any) => Api.createResponse('admin/reports/bills/save',params),
			upload: async (params?: any) => Api.createResponse('admin/reports/bills/upload',params),
			export: async (params?: any) => Api.createResponse('admin/reports/bills/export',params)
		}
	}

}

export default ReportService;